import type { User, RexSystem } from '@/api';


const AUTH_STORAGE_KEY = 'bnovus_auth';

interface StoredAuth {
  user: User;
  token: string;
  tokenExpiry: string;
  isSSO: boolean;
  rexSystems?: RexSystem[];
}

export function storeAuth(auth: StoredAuth): void {
  try {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(auth));
  } catch {
    // eslint-disable-next-line no-console -- intentional silent fallback logging
    console.log('[storage] storeAuth failed');
  }
}

export function getStoredAuth(): StoredAuth | null {
  try {
    const stored = localStorage.getItem(AUTH_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function clearStoredAuth(): void {
  try {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  } catch {
    // eslint-disable-next-line no-console -- intentional silent fallback logging
    console.log('[storage] clearStoredAuth failed');
  }
}
